import { StyleSheet, Text, View } from "@react-pdf/renderer";
import { globalStyles } from "config/pdfStyles";
import { dateFormat } from "helpers/common";

const styles = StyleSheet.create({
  dateLabel: {
    flexDirection: "row",
    alignItems: "center",
    gap: 5,
    marginBottom: 5
  }
})

const AnswerDateRange = ({ answer }) => {
  const dates = answer?.answer?.other_details?.period;
  return (
    <View>
      {dates ? (
        <View style={{ flexDirection: "row", gap: 40 }}>
          <View>
            <View style={styles.dateLabel}>
              <View
                style={{
                  width: 5,
                  height: 5,
                  backgroundColor: "rgb(61, 160, 170)"
                }}
              >
              </View>
              <Text style={globalStyles.fontBold}>
                Start Date
              </Text>
            </View>
            <View>
              <Text>{dates[0] ? dateFormat(dates[0], "MM/DD/YYYY") : "--"}</Text>
            </View>
          </View>
          <View>
            <View style={styles.dateLabel}>
              <View
                style={{
                  width: 5,
                  height: 5,
                  backgroundColor: "rgb(61, 160, 170)"
                }}
              >
              </View>
              <Text style={globalStyles.fontBold}>
                End Date
              </Text>
            </View>
            <View>
              <Text>{dates[0] ? dateFormat(dates[0], "MM/DD/YYYY") : "--"}</Text>
            </View>
          </View>
        </View>
      ) : (
        "--"
      )}
    </View>
  )
}

export default AnswerDateRange;